import { yup } from '@framework/validation/initYup.ts';
import { BooleanConditionSchema } from '../../inputs/expressions-editor/conditions/BooleanConditionSchema.ts';
import { LazyWidgetSchema } from '../../schema/widgets/LazyWidgetSchema.ts';
import { BaseLayoutSchema } from '../../schema/widgets/repository/common/BaseLayoutSchema.ts';
import { type IRootWidget } from '../../schema/widgets/repository/containers/root/IRootWidget.ts';
import { WidgetMainType, WidgetType } from '../../schema/widgets/Widget.ts';

export const RootWidgetSchema: yup.ObjectSchema<IRootWidget> = yup
  .object({
    versionId: yup.number().default(0),
    // Layout
    layout: BaseLayoutSchema,

    fromVirtualId: yup.string().optional(),

    // Regole di visibilità
    visible: BooleanConditionSchema,
    enabled: BooleanConditionSchema,
    type: yup.string().required().exact(WidgetType.Root).label('Tipo'),
    directives: yup.object().default(undefined),
    mainType: yup
      .string()
      .required()
      .exact(WidgetMainType.Root)
      .label('Tipo principale'),
    children: yup
      .array()
      // Valido il form nella sua totalità solo se non è una bozza (e.g. quando viene pubblicato)
      .when('$isDraft', ([isDraft], schema) => {
        if (!isDraft) {
          return schema.of(LazyWidgetSchema).required();
        }
        return schema.notRequired().default([]);
      })
      .default([])
      .label('Form'),
  })
  .noUnknown()
  .required()
  .label('Elementi');
